<template>
  <div>
    <section>
      <div class="imgBx">
        <img src="../../assets/forgotpassword.jpg" alt="" />
      </div>
      <div class="contentBx">
        <div class="formBx">
          <h5 class="auth-logo">
            <div class="banner-container">
              <div class="bbi-banner"></div>
            </div>
            <i class="fa fa-circle text-gray"></i>
            APPS
            <i class="fa fa-circle text-bbi_yellow"></i>
          </h5>
          <h2>Change Password</h2>
          <b-alert class="alert-sm" variant="danger" :show="!!errorMessage">
            {{ errorMessage }}
          </b-alert>
          <form @submit.prevent="submitChangePassword">

            <div class="inputBx">
              <b-form-group id="input-group-6" label="Key :" label-for="input-5">
              <input
                type="text"
                name="userid"
                readonly
                id="userid"
                v-model="inputUserID"
              />
              </b-form-group>
            </div>
            <div class="inputBx">
                <b-form-group id="input-group-6" label="New Password :" label-for="input-5">
        <b-form-input
          id="input-5"
          v-model="newPassword"
          type="password"
          ref="newPassword"
          required
          placeholder="Enter new password"
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-7" label="Confirm New Password :" label-for="input-6">
        <b-form-input
          id="input-6"
          v-model="confirmPassword"
          type="password"
          ref="confirmPassword"
          required
          placeholder="Enter new password once more"
        ></b-form-input>
      </b-form-group>
              </div>

            <div class="inputBx">
              <input type="submit" value="Submit" />
            </div>

          </form>
          <h3>BBI Social Media</h3>
          <ul class="sci">
            <li>
              <router-link to="instagram" class="links__router" target="_blank"
                ><i class="fa fa-instagram"></i
              ></router-link>
            </li>
            <li>
              <router-link to="linkedin" class="links__router" target="_blank"
                ><i class="fa fa-linkedin"></i
              ></router-link>
            </li>
            <li>
              <router-link to="facebook" class="links__router" target="_blank"
                ><i class="fa fa-facebook-f"></i
              ></router-link>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions } from "vuex";
// Import vue recaptcha
import VueRecaptcha from "vue-recaptcha";
import { APIPATH_BBIAPPS } from "../../api/api-paths";
import { fnPOSTCore } from "../../api/api-methods";

export default {
  name: "ForgotPasswordPage",
  components: {
    VueRecaptcha,
  },
  data() {
    const now = new Date();
    const today = now.toISOString().slice(0, 10);
    return {
      inputUserID: null,
      confirmPassword: null,
      newPassword: null,
      errorMessage: null,
      show: true,
      form: {
        robot: false,
      },
    };
  },

  mounted() {
    // Set the user ID from the store
    this.inputUserID = this.$route.query.key
  },
  methods: {
    ...mapActions("session", ["showNotification"]),
    // SubmitForm Forgot Password
    resetForm() {
      this.newPassword = null
      this.confirmPassword = null
    },
    submitChangePassword() {
      this.errorMessage = null;
      if (this.newPassword != this.confirmPassword) {
        this.errorMessage = 'New Password & Confirmation Password Mismatch. Please check your input'
        this.resetForm()
      }
      else {
        fnPOSTCore(APIPATH_BBIAPPS.chPassUUID, {
          username: this.inputUserID,
          new_password: this.newPassword,
          type:'uuid'
        })
          .then(response => {
            this.showNotification({type:'success', message:'Password updated'})
            setTimeout(() => {
              this.$router.push({name:"Login"})
            }, 2000);

          })
          .catch(err => {
            this.errorMessage = err.response.data.message;
        })
      }
    },
  },
};
</script>

<style src="./ChangePassword.scss" lang="scss" scoped />